import { Suspense, ReactNode, FC } from 'react';
import { GridRow, GridCol } from 'dibs-elements/exports/Grid';

import { CheckoutNavigation } from './CheckoutNavigation';
import { CheckoutStepsShimmer } from './CheckoutStepsShimmer';

type Props = {
    children: ReactNode;
};

export const CheckoutStepsSuspense: FC<Props> = props => {
    const loadingShimmer = (
        <>
            <CheckoutNavigation buyer={null} transaction={null} isComputing />
            <CheckoutStepsShimmer />
        </>
    );

    return (
        <GridRow>
            <GridCol
                desktop={8}
                desktopOptions={{ offset: 2 }}
                mobile={10}
                mobileOptions={{ offset: 1 }}
            >
                <Suspense fallback={loadingShimmer}>{props.children}</Suspense>
            </GridCol>
        </GridRow>
    );
};
